/**
 * Hybrid ListItemContent Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps) or the component was extended with styled()
 * (isStyledExtension). Otherwise renders the Tailwind path (preferred — no
 * runtime CSS-in-JS).
 */
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";
import type { TypeListItemContentProps } from "./ListItemTypes";
import ListItemContentStyled from "./ListItemContentStyled";
import ListItemContentTailwind from "./ListItemContentTailwind";

const ListItemContentHybrid = (props: TypeListItemContentProps) => {
  if (hasStyledProps(props) || isStyledExtension(props)) {
    return <ListItemContentStyled {...props} />;
  }

  return <ListItemContentTailwind {...props} />;
};

ListItemContentHybrid.displayName = "ListItemContent";

export default ListItemContentHybrid;
